import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { BillableRateResponse } from '@/modules/configurationModule/detail/local-accounting/billable/rates/services/configuration-local-accounting-billable-rates/billable-rate.dto'
import { billableRateService } from '@/modules/configurationModule/detail/local-accounting/billable/rates/services/configuration-local-accounting-billable-rates/billable-rate.service'
import { store } from '@/store/store'

export enum ConfigurationLocalAccountingRatesGridSidepanelComboElements {
    CONCEPTS = 1,
    CLIENTS = 2
}

export const localAccountingRatesColumnsDef =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.rate'),
            field: 'name',
            minWidth: 250,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.code'),
            field: 'code',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.unit'),
            field: 'accountingUnit.name',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.DATE,
            headerName: i18n.tc('configuration.grid.startDate'),
            field: 'startDate',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.DATE,
            headerName: i18n.tc('configuration.grid.endDate'),
            field: 'endDate',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.copayment'),
            field: 'allowsCopayment',
            minWidth: 80,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('configuration.grid.invoiceTo'),
            field: 'copaymentType',
            type: AgGridColumnType.BILLING_COPAYMENT_TYPE,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.default'),
            field: 'isDefault',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface ConfigurationLocalAccountingRatesGridStateSidepanel {
    show: boolean
    title: string
}

export interface ConfigurationLocalAccountingRatesGridState extends CrudModelPaginatorLaboratory<BillableRateResponse> {
    service: typeof billableRateService
    laboratoryId: number
}
export const initialConfigurationLocalAccountingRatesGridState =
    (): ConfigurationLocalAccountingRatesGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.accounting.rates',
        columnsDef: localAccountingRatesColumnsDef(),
        datasource: new PaginatorLaboratoryDatasource(billableRateService, store.getters.labId),
        service: billableRateService,
        laboratoryId: store.getters.labId
    })
